import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Media from 'components/common/Media'
import { H2 } from 'components/common/Text/Text'
import Banner from 'components/common/Banner/Banner'
import { Title, Instructions } from '../../components/Recovery/ForgotPages.styles'
import CreateAccountForm from './components/CreateAccountForm'

const CreateAccountFormPageWrapper = ({
  error,
  instructions,
  setInnerRef,
  ...props
}) =>
  <Container data-at-create-accoun>
    <Title data-at-title narrow noMargin>CREATE AN ACCOUNT</Title>
    <Banner data-at-error-message error_alternative hidden={ !error } setInnerRef={ setInnerRef } tabIndex="-1">{ error }</Banner>
    <Instructions data-at-instructions>{ instructions }</Instructions>
    <H2 data-at-sub-title bold size={ 16 } noMargin>SET UP YOUR ACCOUNT</H2>
    <CreateAccountForm msHideCross { ...props } error={ error } />
  </Container>

CreateAccountFormPageWrapper.propTypes = {
  error: PropTypes.oneOfType(
    [PropTypes.string, PropTypes.array]
  ),
  handleModalClose: PropTypes.func,
  handleModalOpen: PropTypes.func,
  handleRedirect: PropTypes.func,
  instructions: PropTypes.string,
  isModalShowing: PropTypes.bool,
  isSubmitSucceeded: PropTypes.bool,
  message: PropTypes.string,
  pageSrc: PropTypes.string,
  setInnerRef: PropTypes.func,
  status: PropTypes.shape({
    code: PropTypes.string,
    description: PropTypes.string
  })
}

export default CreateAccountFormPageWrapper

const Container = styled.div`
  width: 35em;
  padding: 85px 0 125px;
  margin: 0 auto;
  ${Media.mobile`
    width: 100%;
    padding: 71px 15px 39px;
  `}
`
